"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfferFieldDriverLicence = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const icons_1 = require("@ant-design/icons");
const elements_1 = require("@src/components/elements");
const DriverLicenceSelectField_1 = require("@src/components/modules/forms/DriverLicenceSelectField");
const types_1 = require("@src/types");
const antd_1 = require("antd");
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const styled_breakpoints_1 = require("styled-breakpoints");
const react_styled_1 = require("styled-breakpoints/react-styled");
const styled_components_1 = __importDefault(require("styled-components"));
const OfferFieldMileage_1 = require("./OfferFieldMileage");
const DriverLicenceSelectFieldWrapper = styled_components_1.default.div `
	max-width: 12rem;
	width: 12rem;
	margin-right: 1rem;
`;
const MileageFieldWrapper = styled_components_1.default.div `
	max-width: 12rem;
	width: 12rem;
	margin-right: 1rem;
`;
const RemoveButton = (0, styled_components_1.default)(elements_1.Button) `
	margin-bottom: 1.5rem;
`;
const AddButton = (0, styled_components_1.default)(elements_1.Button) `
	white-space: normal;
	height: auto;
`;
const OfferFieldDriverLicence = ({ getFieldValue }) => {
    const intl = (0, react_intl_1.useIntl)();
    const isBelowXs = (0, react_styled_1.useBreakpoint)((0, styled_breakpoints_1.down)('xs'));
    return ((0, jsx_runtime_1.jsx)(antd_1.Form.List, { name: types_1.EOfferBasicInfoFormField.driverLicences, children: (fields, { add, remove }) => ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [fields.map(({ key, name: listName }) => ((0, jsx_runtime_1.jsxs)("div", { className: "flex-row align-end", children: [(0, jsx_runtime_1.jsx)(DriverLicenceSelectFieldWrapper, { children: (0, jsx_runtime_1.jsx)(DriverLicenceSelectField_1.DriverLicenceSelectField, { name: types_1.EOfferBasicInfoFormField.driverLicence, label: intl.formatMessage({ id: 'admin.offer_form.driver_licence' }), listName: listName, listFieldName: types_1.EOfferBasicInfoFormField.driverLicences, rules: [
                                    {
                                        required: true,
                                        message: intl.formatMessage({
                                            id: 'admin.offer_form.choose_driver_licence',
                                        }),
                                    },
                                ], placeholder: types_1.DriverLicence.B1, getFieldValue: getFieldValue }) }), (0, jsx_runtime_1.jsx)(MileageFieldWrapper, { children: (0, jsx_runtime_1.jsx)(OfferFieldMileage_1.OfferFieldMileage, { name: types_1.EOfferBasicInfoFormField.mileage, label: intl.formatMessage({
                                    id: 'admin.offer_form.mileage',
                                }), listName: listName }) }), !isBelowXs && ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(RemoveButton, { onClick: () => remove(listName), size: "middle", type: "default", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "global.remove" }) }) })), isBelowXs && ((0, jsx_runtime_1.jsx)("div", { className: "m-b-l", children: (0, jsx_runtime_1.jsx)(icons_1.MinusCircleOutlined, { onClick: () => remove(listName) }) }))] }, key))), (0, jsx_runtime_1.jsx)(antd_1.Form.Item, { children: (0, jsx_runtime_1.jsx)(AddButton, { type: "dashed", onClick: () => add(), block: true, icon: (0, jsx_runtime_1.jsx)(icons_1.PlusOutlined, {}), children: (0, jsx_runtime_1.jsx)("span", { className: "m-l-s", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "admin.offer_form.add_driver_licence" }) }) }) })] })) }));
};
exports.OfferFieldDriverLicence = OfferFieldDriverLicence;
